<template>
  <router-view />
</template>

<script setup>
import { lang } from 'store/lang.store'
import { loadLocaleMessages } from './i18n'
import { useI18n } from 'vue-i18n'

// Seta o locale de acordo com o lang
const { locale } = useI18n({ useScope: 'global' })

loadLocaleMessages(lang.value)

locale.value = lang.value
</script>

<style lang="scss" scoped></style>
